<div class="showcase-grid">

  <div class="showcase-card"
       *ngFor="let item of images">

    <div class="image-wrapper">
      <img [src]="item.fileUrl"
           [alt]="item.title">
    </div>

    <div class="content">
      <h3>{{ item.title }}</h3>
      <p>{{ item.desc }}</p>
    </div>

  </div>

</div>